import { useIntl } from 'react-intl'

import { SubscriptionInfo } from 'features/home/types'

import {
  StyledHomeSubscriptionPlan,
  StyledHomeSubscriptionPlanIcon,
  PlanName,
} from './styles'
import SubscriptionIcon from 'components/Icons/SubscriptionIcon'
import { commonMessages } from 'app/i18n/messages'

interface DomainsHomeSubscriptionPlanProps {
  subscriptionInfo: SubscriptionInfo | null
}

function DomainsHomeSubscriptionPlan(props: DomainsHomeSubscriptionPlanProps) {
  const { subscriptionInfo } = props
  const { formatMessage } = useIntl()

  switch (subscriptionInfo?.category) {
    case 'ESSENTIALS':
      return (
        <StyledHomeSubscriptionPlan>
          <StyledHomeSubscriptionPlanIcon>
            <SubscriptionIcon subscriptionInfo={subscriptionInfo} />
          </StyledHomeSubscriptionPlanIcon>
          <PlanName>{formatMessage(commonMessages.essentialPlan)}</PlanName>
        </StyledHomeSubscriptionPlan>
      )
    case 'NETWORK':
      return (
        <StyledHomeSubscriptionPlan>
          <StyledHomeSubscriptionPlanIcon>
            <SubscriptionIcon subscriptionInfo={subscriptionInfo} />
          </StyledHomeSubscriptionPlanIcon>
          <PlanName>{formatMessage(commonMessages.networkPlan)}</PlanName>
        </StyledHomeSubscriptionPlan>
      )
    default:
      return (
        <StyledHomeSubscriptionPlan>
          <StyledHomeSubscriptionPlanIcon>
            <SubscriptionIcon subscriptionInfo={subscriptionInfo} />
          </StyledHomeSubscriptionPlanIcon>
          <PlanName />
        </StyledHomeSubscriptionPlan>
      )
  }
}

export default DomainsHomeSubscriptionPlan
